export default class Role {
  constructor(code, desc) {
    this.code = code;
    this.desc = desc;
  }

  getCode() {
    return this.code;
  }

  getDesc() {
    return this.desc;
  }
}

Role.CUSTOMERROLE_ROOT = new Role(10, '超级管理员');
// Role.CUSTOMERROLE_ADMIN = new Role(1, "普通管理员"); // 废弃角色
Role.OPERATOR_ROLE_LEADS_CMANAGER = new Role(90003, '普通管理员');
Role.OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER = new Role(90007, '客服经理');
// Role.CUSTOMERROLE_OPERATOR = new Role(3, "普通员工"); // 废弃角色
Role.OPERATOR_ROLE_LEADS_CEMPLOYEE = new Role(90004, '客服人员');
Role.CUSTOMERROLE_AGENCYEMPLOYEE = new Role(90005, '服务商人员');
Role.CUSTOMERROLE_ADOPERATION = new Role(90006, '广告优化师');
Role.OPERATOR_ROLE_LEADS_ASSISTANT = new Role(90009, '线索转发助手');
Role.OPERATOR_ROLE_LEADS_DATA_ANALYST = new Role(90011, '数据分析人员');
Role.OPERATOR_ROLE_LEADS_OTHER = new Role(99999, '其他角色');

Object.freeze(Role);
